const state = () => ({
    FloorId: '',
   
})
const getters = {
    FloorId: (state) => state.FloorId,
   
}
const mutations = {

    setFloorId(state, FloorId) {
        state.FloorId = FloorId
    },
 
}
const actions = {
    setFloorId({ commit }, FloorId) {
        commit('setFloorId', FloorId)
    },
   
}
export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/equipment.js